import {useAufgabenHandling} from "../../hooks/aufgaben/useAufgabenHandling";
import Layout from "../../components/Layout";
import {capitalize, DialogActions, DialogContent, Paper, Typography} from "@mui/material";
import {aufgabenStyles} from "../../styles/aufgaben/aufgaben.styles";
import {Form, Formik, FormikProps} from "formik";
import FieldsContentAufgabe from "../../components/aufgaben/FieldsContentAufgabe";
import SubmitButton from "../../components/SubmitButton";
import {useAufgabeCreateForm} from "../../hooks/aufgaben/useAufgabeCreateForm";
import ErrorAlert from "../../components/ErrorAlert";
import {notPermitted} from "../../errors";
import {permissions} from "../../permissions";
import MultipleGuard from "../../components/guards/MultipleGuard";
import TemplateHandling from "../../components/aufgaben/TemplateHandling";
import type { AufgabeFormValues } from "../../types/aufgabenTypes";

export default function PageCreateAufgabe() {
    const {translation, canCreateAufgabeField} = useAufgabenHandling();
    const formikProps = useAufgabeCreateForm();

    return (
        <Layout
            title={capitalize(translation('task-create'))}
            back={"/aufgaben"}
        >
            <MultipleGuard
                permissions={[
                    permissions.aufgaben.create,
                    permissions.aufgaben.own_create,
                ]}
                fallback={<ErrorAlert error={notPermitted()}/>}
            >
                <Paper id={'page-create-aufgabe-paper'}
                       elevation={1}
                       sx={aufgabenStyles.pageCreateAufgabe.paper}
                >
                    <Formik {...formikProps}>
                        {({isSubmitting, isValidating, isValid, dirty}: FormikProps<AufgabeFormValues>) => (

                            <Form id={'form-create-aufgabe'}>
                                <Typography variant="h5">
                                    {capitalize(translation('task-create'))}
                                </Typography>
                                <DialogContent id={'page-create-aufgabe-dialog-content'}>
                                    <TemplateHandling/>
                                    <FieldsContentAufgabe canEditFields={canCreateAufgabeField()}/>
                                </DialogContent>
                                <DialogActions id={'page-create-aufgabe-dialog-actions'}>
                                    <SubmitButton id={'page-create-aufgabe-submit-button'}
                                                  form={'form-create-aufgabe'}
                                                  type={'submit'}
                                                  variant={'contained'}
                                                  color={'secondary'}
                                                  loading={isSubmitting}
                                                  disabled={isValidating || !isValid || !dirty}
                                    >
                                        {isSubmitting ? capitalize(translation('creating')) : capitalize(translation('create'))}
                                    </SubmitButton>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </Paper>
            </MultipleGuard>
        </Layout>
    );
}